import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import openai from '../../../services/openaiClient';

const ClientFollowUpActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('schedule');
  const [aiQuery, setAiQuery] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const [isLoadingAI, setIsLoadingAI] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [followUpTime, setFollowUpTime] = useState('');
  const [followUpNotes, setFollowUpNotes] = useState('');
  const [selectedClient, setSelectedClient] = useState('');

  const handleAIFollowUpSuggestion = async () => {
    setIsLoadingAI(true);
    try {
      const completion = await openai?.chat?.completions?.create({
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'أنت مساعد ذكي متخصص في متابعة العملاء في قطاع العقارات. قدم اقتراحات لأفضل أوقات المتابعة وأساليب التواصل الفعالة.'
          },
          {
            role: 'user',
            content: aiQuery || 'اقترح أفضل استراتيجية لمتابعة العملاء المتأخرين'
          }
        ],
        temperature: 0.7,
        max_tokens: 500
      });
      
      setAiResponse(completion?.choices?.[0]?.message?.content || 'لم يتم الحصول على رد');
    } catch (error) {
      console.error('AI Analysis Error:', error);
      setAiResponse('حدث خطأ في تحليل الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsLoadingAI(false);
    }
  };

  const handleScheduleFollowUp = () => {
    if (!followUpDate || !followUpTime || !selectedClient) {
      alert('يرجى ملء جميع الحقول المطلوبة');
      return;
    }
    console.log('Scheduling follow-up:', { followUpDate, followUpTime, selectedClient, followUpNotes });
    alert('تم جدولة المتابعة بنجاح');
  };

  const tabs = [
    { id: 'schedule', label: 'جدولة متابعة', icon: 'Calendar' },
    { id: 'ai-suggestions', label: 'اقتراحات ذكية', icon: 'Sparkles' },
    { id: 'history', label: 'سجل المتابعات', icon: 'History' }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="متابعة العملاء"
      icon="Users"
      iconColor="#10B981"
      size="xl"
      footer={null}
    >
      {/* Tabs */}
      <div className="flex gap-2 mb-6 border-b border-border">
        {tabs?.map(tab => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-semibold' : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'schedule' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">جدولة متابعة جديدة</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">اختر العميل</label>
                <select
                  value={selectedClient}
                  onChange={(e) => setSelectedClient(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                >
                  <option value="">-- اختر عميل --</option>
                  <option value="client-1">أحمد محمد السعيد</option>
                  <option value="client-2">فاطمة خالد المنصوري</option>
                  <option value="client-3">محمد عبدالله الأحمد</option>
                  <option value="client-4">سارة علي الحسن</option>
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-2">تاريخ المتابعة</label>
                  <Input
                    type="date"
                    value={followUpDate}
                    onChange={(e) => setFollowUpDate(e?.target?.value)}
                    className="w-full"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-2">وقت المتابعة</label>
                  <Input
                    type="time"
                    value={followUpTime}
                    onChange={(e) => setFollowUpTime(e?.target?.value)}
                    className="w-full"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">ملاحظات المتابعة</label>
                <textarea
                  value={followUpNotes}
                  onChange={(e) => setFollowUpNotes(e?.target?.value)}
                  placeholder="أضف ملاحظات حول المتابعة..."
                  rows={4}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background resize-none"
                />
              </div>

              <Button
                onClick={handleScheduleFollowUp}
                className="w-full"
                variant="primary"
              >
                <span className="flex items-center gap-2">
                  <Icon name="Calendar" size={18} />
                  جدولة المتابعة
                </span>
              </Button>
            </div>

            <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
              <div className="flex items-start gap-2">
                <Icon name="Info" size={20} className="text-green-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-green-900 mb-1">نصيحة</h4>
                  <p className="text-sm text-green-800">
                    أفضل أوقات المتابعة هي صباحاً بين 9-11 أو مساءً بين 5-7. تجنب أوقات الغداء والعطلات.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'ai-suggestions' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">اقتراحات ذكية للمتابعة</h3>
            
            <div className="space-y-3">
              <label className="block text-sm font-medium">اسأل عن استراتيجية المتابعة</label>
              <Input
                value={aiQuery}
                onChange={(e) => setAiQuery(e?.target?.value)}
                placeholder="مثال: كيف أتابع مع عميل لم يرد على اتصالاتي منذ أسبوع؟"
                className="w-full"
              />
              <Button
                onClick={handleAIFollowUpSuggestion}
                disabled={isLoadingAI}
                className="w-full"
              >
                {isLoadingAI ? (
                  <span className="flex items-center gap-2">
                    <Icon name="Loader" size={18} className="animate-spin" />
                    جاري التحليل...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Icon name="Sparkles" size={18} />
                    احصل على اقتراحات
                  </span>
                )}
              </Button>
            </div>

            {aiResponse && (
              <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start gap-2 mb-2">
                  <Icon name="Lightbulb" size={20} className="text-blue-600 mt-1" />
                  <h4 className="font-semibold text-blue-900">اقتراحات الذكاء الاصطناعي</h4>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{aiResponse}</p>
              </div>
            )}

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4 border border-border rounded-lg">
                <Icon name="Phone" size={24} className="text-blue-600 mb-2" />
                <h4 className="font-semibold mb-1">متابعة هاتفية</h4>
                <p className="text-sm text-muted-foreground">الأنسب للعملاء ذوي الأولوية العالية</p>
              </div>
              
              <div className="p-4 border border-border rounded-lg">
                <Icon name="Mail" size={24} className="text-green-600 mb-2" />
                <h4 className="font-semibold mb-1">متابعة بالبريد</h4>
                <p className="text-sm text-muted-foreground">مناسبة للمتابعات الرسمية</p>
              </div>
              
              <div className="p-4 border border-border rounded-lg">
                <Icon name="MessageSquare" size={24} className="text-purple-600 mb-2" />
                <h4 className="font-semibold mb-1">رسالة نصية</h4>
                <p className="text-sm text-muted-foreground">سريعة وفعالة للتذكيرات</p>
              </div>
              
              <div className="p-4 border border-border rounded-lg">
                <Icon name="Video" size={24} className="text-orange-600 mb-2" />
                <h4 className="font-semibold mb-1">اجتماع افتراضي</h4>
                <p className="text-sm text-muted-foreground">للعروض التفصيلية</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'history' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">سجل المتابعات</h3>
            
            <div className="space-y-3">
              <div className="p-4 border border-border rounded-lg hover:bg-muted/30 transition-colors">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Icon name="User" size={18} className="text-blue-600" />
                    <span className="font-semibold">أحمد محمد السعيد</span>
                  </div>
                  <span className="text-xs text-muted-foreground">٢٠٢٦/٠١/١٠</span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">تم الاتصال بالعميل ومناقشة العروض المتاحة</p>
                <div className="flex items-center gap-2">
                  <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded">مكتمل</span>
                  <span className="text-xs text-muted-foreground">بواسطة: سارة أحمد</span>
                </div>
              </div>

              <div className="p-4 border border-border rounded-lg hover:bg-muted/30 transition-colors">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Icon name="User" size={18} className="text-blue-600" />
                    <span className="font-semibold">فاطمة خالد المنصوري</span>
                  </div>
                  <span className="text-xs text-muted-foreground">٢٠٢٦/٠١/٠٩</span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">إرسال بريد إلكتروني بالعروض الجديدة</p>
                <div className="flex items-center gap-2">
                  <span className="px-2 py-1 bg-yellow-100 text-yellow-700 text-xs rounded">قيد الانتظار</span>
                  <span className="text-xs text-muted-foreground">بواسطة: أحمد محمد</span>
                </div>
              </div>

              <div className="p-4 border border-border rounded-lg hover:bg-muted/30 transition-colors">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Icon name="User" size={18} className="text-blue-600" />
                    <span className="font-semibold">محمد عبدالله الأحمد</span>
                  </div>
                  <span className="text-xs text-muted-foreground">٢٠٢٦/٠١/٠٨</span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">جدولة معاينة عقار في الريم</p>
                <div className="flex items-center gap-2">
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded">مجدول</span>
                  <span className="text-xs text-muted-foreground">بواسطة: محمد خالد</span>
                </div>
              </div>
            </div>

            <Button variant="outline" className="w-full">
              <span className="flex items-center gap-2">
                <Icon name="Download" size={18} />
                تصدير السجل
              </span>
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ClientFollowUpActionsModal;